// The blue chips a passing module shows while other modules' picks are on (Ben, 2026-10-21): one per
// module, "Passing Report: Hard passes ✕". ✕ drops that module's pick everywhere; the others stay.

import { releasePasses } from "../engines/event-link.js";
import type { LinkedSelection } from "./useLinkedSelection.js";

export function LinkedChip({ linked }: { linked: LinkedSelection }) {
  return (
    <>
      {linked.picks.map(({ sel, from }) => (
        <span key={from + sel.label} className="filter-chip focus-chip linked-chip" title={`Picked in the ${from}`}>
          <span className="chip-value">
            {from}: {sel.label}
          </span>
          <span className="remove" title="Clear this pick everywhere" onClick={() => releasePasses(sel.source)}>
            ✕
          </span>
        </span>
      ))}
    </>
  );
}
